import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.service';
import { AuthRow } from 'auxilium-connect';
import { environment } from 'src/environments/environment';
import { LanguageDef } from 'src/lang';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  readonly env = environment;
  spoke: string;
  auth: AuthRow;
  language: keyof LanguageDef;

  constructor(
    public app: AppService,
    private _api: ApiService,
    private _cd: ChangeDetectorRef
  ) {
    this._api.fetchInterfaces().subscribe();
    this.language = app.language;
  }

  // testConfirm() {
  // 	this.app.confirm({
  // 		message: 'do you want to do the thing?',
  // 		title: 'this is a title',
  // 		translate: true
  // 	}).subscribe(resp => {
  // 		console.warn('responded', resp);
  // 	})
  // }

  changeLanguage(to: keyof LanguageDef) {
    this.app.changeLanguage(to);
    this.language = to;
    this._cd.detectChanges();
  }

  logout() {
    this._api.logout().subscribe((resp) => this._cd.detectChanges());
  }

  ngOnInit() {
    this._checkTitle();
    this.spoke = this._api.spoke; // needed for the user menu also
    this.app.auth.subscribe((a) => (this.auth = a)); // needed for the user menu

    document.documentElement.style.setProperty('--theme-deafult', '#3f51b5');
  }

  private _checkTitle() {
    const chunks = this.app.title.getTitle().split('**'),
      len = chunks.length;
    if (len === 3 && !chunks[0] && !chunks[len - 1]) {
      console.warn(
        'your app title has no been set - please edit the index.html'
      );
    }
  }
}
